import { styled, InputBase as MuiInputBase } from '@mui/material';

export const InputBase = styled(MuiInputBase)({
  '& .MuiInputBase-input': {
    padding: 'calc(var(--spacer) * 0.13) 0px calc(var(--spacer) * 0.17)',
    '&::placeholder': {
      opacity: 1,
      color: 'var(--text-secondary-color)',
      fontWeight: 'var(--font-weight-normal)'
    }
  }
});
